export default `
  {
    suggestedStats { 
      approved
      reported 
      noticed
      noticedPrevWeek
    }
  }
`;